import React, { createContext, useEffect, useState } from "react";
import axios from "axios";
import getBaseUri from "../getBaseUri";

export const HomeContext = createContext();

export const HomeProvider = ({ children }) => {
  const [acfData, setAcfData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  // ✅ Fix: Move getMediaUrl OUTSIDE fetchHomePage
  const getMediaUrl = async (mediaId) => {
    if (!mediaId) return null;
    try {
      const baseUri = getBaseUri();
      const mediaResponse = await axios.get(
        `${baseUri}/wp-json/wp/v2/media/${mediaId}`
      );
      return mediaResponse.data.source_url;
    } catch (error) {
      console.error(`Error fetching media for ID ${mediaId}:`, error);
      return null;
    }
  };

  useEffect(() => {
    const fetchHomePage = async () => {
      const baseUri = getBaseUri();
      try {
        const response = await axios.get(
          `${baseUri}/wp-json/wp/v2/pages?slug=home`
        );

        if (response.data?.length) {
          const pageData = response.data[0];
          if (pageData.acf) {
            const acf = pageData.acf;
            const fetchedAcfData = {
              mainBrandContent: acf.main_brand_content || "Maamangala Studio",
              heroBackgroundImage:
                (await getMediaUrl(acf.hero_background_image)) ||
                "https://studiomaamangala.com/wp-content/uploads/2025/01/Lars-Peeters.png",
            };

            setAcfData(fetchedAcfData);
          }
        }
      } catch (error) {
        console.error("Error fetching home page data:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchHomePage();
  }, []); // ✅ Fix: Remove setAcfData from dependency array (useEffect should run only once)

  // ✅ Mouse move event handler
  useEffect(() => {
    const handleMouseMove = (event) => {
      setMousePosition({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <HomeContext.Provider
      value={{ acfData, setAcfData, loading, error, mousePosition }}
    >
      {children}
    </HomeContext.Provider>
  );
};
